module.exports = __webpack_public_path__ + "9f393a411e10c079571051b1c3b6b075.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_50.mp3
// module id = 418
// module chunks = 0